import { render, staticRenderFns } from "./SubjectComponent.vue?vue&type=template&id=a4590b5a&scoped=true&"
import script from "./SubjectComponent.vue?vue&type=script&lang=js&"
export * from "./SubjectComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubjectComponent.vue?vue&type=style&index=0&id=a4590b5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4590b5a",
  null
  
)

export default component.exports